import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import SalaryCutsActions from '../../../../reducers/modules/hr/salary-cuts/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'hr/salary-cuts'

export default class SalaryCutsMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(SalaryCutsActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      SalaryCutsMiddleware.showOne(dispatch, params);
      dispatch(SalaryCutsActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(SalaryCutsActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(SalaryCutsActions.process());
          SalaryCutsMiddleware.showlist(dispatch, params);
        };
  }
  static reset(){
    return (dispatch) => {
        dispatch(SalaryCutsActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(SalaryCutsActions.view());
        SalaryCutsMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(SalaryCutsActions.submit());
        SalaryCutsMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(params,post,search){
    return (dispatch) => {
        dispatch(SalaryCutsActions.submit());
        SalaryCutsMiddleware.saveUpdate(dispatch, params, post,search);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(SalaryCutsActions.delete());
        SalaryCutsMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      SalaryCutsMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-salary-cuts' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        SalaryCutsMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${SalaryCutsMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(SalaryCutsActions.list(response.data.result));
          }
        })
        .catch((error) => {
          SalaryCutsMiddleware.alertHendler(dispatch,error)
        });
  }

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsActions.view(response.data.result));
        }
      })
      .catch((error) => {
        SalaryCutsMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(SalaryCutsActions.process(),SalaryCutsMiddleware.showlist(dispatch, params));
          SalaryCutsMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        SalaryCutsMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${SalaryCutsMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsActions.process(),SalaryCutsMiddleware.showlist(dispatch,search));
          dispatch(SalaryCutsActions.success());
          SalaryCutsMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        SalaryCutsMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post, search){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${SalaryCutsMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(SalaryCutsActions.process(),SalaryCutsMiddleware.showlist(dispatch,search));
          dispatch(SalaryCutsActions.success());
          SalaryCutsMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        SalaryCutsMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(SalaryCutsActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(SalaryCutsActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
